import { StyleSheet } from 'react-native';
import { Neutrals } from 'src/theme-v2/colors';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const style = StyleSheet.create({
  errorWrapper: {
    flex: 1,
    width: '100%',
  },
  errorContentContainerStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: 300,
  },
  errorInnerContentContainerStyle: {
    gap: 10,
    width: '100%',
    height: '100%',
  },
  errorInnerWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  errorDescriptionCenter: {
    ...textLatoStyleDS.BodyRegularMd,
    textAlign: 'center',
    color: Neutrals.neutralGreys.GreyNatural850,
  },
});
